module.exports = __webpack_public_path__ + "img/logo.df27c1c0.png";